import { useEffect } from "react";

export function CompareBar({ compareList, toggleCompare, onOpen, onClear }) {
  if (compareList.length < 2) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-navy border-t border-white/20 shadow-2xl z-40 px-4 py-3" data-testid="compare-bar">
      <div className="max-w-5xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-white/60 font-body text-sm">Comparing {compareList.length}/3:</span>
          {compareList.map((l) => (
            <span key={l.id} className="bg-white/10 text-white text-xs font-body px-3 py-1.5 rounded-full flex items-center gap-1.5">
              {l.name.slice(0, 20)}{l.name.length > 20 && "..."}
              <button onClick={() => toggleCompare(l)} className="text-white/40 hover:text-white ml-1">&times;</button>
            </span>
          ))}
        </div>
        <div className="flex gap-2">
          <button onClick={onOpen} className="bg-brand-red hover:bg-red-800 text-white px-5 py-2 rounded-full font-body text-sm font-semibold transition-colors" data-testid="compare-open-btn">Compare</button>
          <button onClick={onClear} className="text-white/50 hover:text-white font-body text-sm px-3">Clear</button>
        </div>
      </div>
    </div>
  );
}

const COMPARE_ROWS = [
  { label: "Grade", fn: (l) => l.healthGrade || "—" },
  { label: "Rating", fn: (l) => l.googleRating ? `${l.googleRating} / 5` : "—" },
  { label: "Reviews", fn: (l) => l.reviewCount || 0 },
  { label: "Category", fn: (l) => l.category || "—" },
  { label: "Zone", fn: (l) => l.zone || "—" },
  { label: "Domains", fn: (l) => l.cpiDomains?.join(", ") || "—" },
];

export function CompareModal({ open, compareList, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl max-w-4xl w-full p-6 shadow-xl overflow-x-auto" onClick={(e) => e.stopPropagation()} data-testid="compare-modal">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-2xl text-navy font-bold">Compare Venues</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-navy text-2xl" data-testid="compare-close-btn">&times;</button>
        </div>
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left font-body text-xs text-gray-500 uppercase py-3 pr-4 w-32">Attribute</th>
              {compareList.map((l) => <th key={l.id} className="text-left font-body text-sm font-bold text-navy py-3 px-4">{l.name}</th>)}
            </tr>
          </thead>
          <tbody className="font-body text-sm">
            {COMPARE_ROWS.map((row) => (
              <tr key={row.label} className="border-b border-gray-50">
                <td className="py-3 pr-4 text-gray-500 text-xs uppercase">{row.label}</td>
                {compareList.map((l) => <td key={l.id} className="py-3 px-4 text-gray-700">{row.fn(l)}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
